import { apiClient } from './client';

export interface EmployeeIdentification {
  national_id_type: string | null; national_id_number: string | null;
  passport_number: string | null; passport_expiry_date: string | null;
  drivers_licence_number: string | null; drivers_licence_expiry_date: string | null;
  other_identification: string | null;
}

export interface EmployeeQualification {
  id: number; qualification_type: 'degree' | 'certification' | 'membership' | 'language';
  title: string; institution: string | null; field_of_study: string | null; year_obtained: number | null; notes: string | null;
}

export interface CompensationHistoryEntry {
  id: number; previous_base_salary: string | null; new_base_salary: string; currency: string;
  effective_date: string; reason: string | null; changed_by_name: string; created_at: string;
}

export interface ProjectAssignment {
  id: number; project_id: number; project_name: string; project_reference: string;
  role_on_project: string | null; allocation_percentage: string | null; start_date: string; end_date: string | null; is_active: number;
}

export const identificationApi = {
  get: (employeeId: number) => apiClient.get<{ data: EmployeeIdentification | null }>(`/api/employees/${employeeId}/identification`),
  upsert: (employeeId: number, input: Partial<Record<keyof EmployeeIdentification, string | null>>) =>
    apiClient.put<{ data: { employeeId: number } }>(`/api/employees/${employeeId}/identification`, input),
};

export const qualificationApi = {
  mine: () => apiClient.get<{ data: EmployeeQualification[] }>('/api/qualifications/mine'),
  createMine: (input: { qualificationType: string; title: string; institution?: string; fieldOfStudy?: string; yearObtained?: number }) =>
    apiClient.post<{ data: { id: number } }>('/api/qualifications/mine', input),
  deleteMine: (id: number) => apiClient.delete<{ data: { id: number } }>(`/api/qualifications/mine/${id}`),
  listForEmployee: (employeeId: number) => apiClient.get<{ data: EmployeeQualification[] }>(`/api/employees/${employeeId}/qualifications`),
  createForEmployee: (employeeId: number, input: { qualificationType: string; title: string; institution?: string; fieldOfStudy?: string; yearObtained?: number }) =>
    apiClient.post<{ data: { id: number } }>(`/api/employees/${employeeId}/qualifications`, input),
  deleteForEmployee: (employeeId: number, id: number) => apiClient.delete<{ data: { id: number } }>(`/api/employees/${employeeId}/qualifications/${id}`),
};

export const compensationHistoryApi = {
  list: (employeeId: number) => apiClient.get<{ data: CompensationHistoryEntry[] }>(`/api/employees/${employeeId}/compensation-history`),
  mine: () => apiClient.get<{ data: CompensationHistoryEntry[] }>('/api/employees/me/compensation-history'),
};

export const projectAssignmentApi = {
  listForEmployee: (employeeId: number) => apiClient.get<{ data: ProjectAssignment[] }>(`/api/employees/${employeeId}/project-assignments`),
  mine: () => apiClient.get<{ data: ProjectAssignment[] }>('/api/employees/me/project-assignments'),
  create: (employeeId: number, input: { projectId: number; roleOnProject?: string; allocationPercentage?: number; startDate: string }) =>
    apiClient.post<{ data: { id: number } }>(`/api/employees/${employeeId}/project-assignments`, input),
  end: (id: number, endDate: string) => apiClient.post<{ data: { id: number } }>(`/api/project-assignments/${id}/end`, { endDate }),
};
